import { types, Instance, SnapshotIn, getRoot } from 'mobx-state-tree';
import { withSchemas } from './extensions/withSchemas';
import { AnyJsonValue } from './GeoJSON';
import { IRootStoreAny } from './rootUtilType';
export const ActivityType = types.model('ActivityType', {
  id: types.string,
  name: types.string,
  canonical_name: types.string,
  extra_schema: types.maybeNull(types.map(types.late(() => AnyJsonValue)))
}).views(self => ({
  get root() {
    return getRoot<IRootStoreAny>(self);
  },
  get properties() {
    return self.extra_schema?.get('properties');
  },
  get required() {
    return self.extra_schema?.get('required');
  },
  get apiSchema() {
    return self.extra_schema?.toJSON();
  }
})).extend(withSchemas).views(self => ({
  get schema() {
    return {
      inspection: self.inspectionSchema,
      fertilization: self.fertilizationSchema,
      harvesting: self.harvestingSchema,
      soil_observation: self.soilObservationSchema,
      planting: self.plantingSchema,
      water_supply: self.waterSupplySchema,
      land_preparation: self.landPreparationSchema,
      straw_management: self.strawManagementSchema,
      pest_disease: self.pestDiseaseSchema,
      straw_incorporation: self.strawIncorporationSchema,
      cover_crop_planting: self.coverCropPlantingSchema,
      none: null
    }[self.canonical_name.toLowerCase() || 'none'];
  }
}));
export type IActivityType = Instance<typeof ActivityType>;
export type IActivityTypeSnapshotIn = SnapshotIn<typeof ActivityType>;